<template>
  <div class="detailBox-box">
    <el-dialog
      title="新增分红纪录"
      :visible.sync="dialogVisible"
      @closed="closeDialog"
    >
      <div class="box">
        <!--新增纪录步骤-->
        <!--1.先调用分红记录相关数据 添加默认参数. 只能编辑结束时间 和 两个比例-->
        <!----2.get 分红纪录---->
        <!----3. emit 刷新父页面--->
        <el-form
          ref="form"
          label-position="right"
          :model="form"
          label-width="180px"
        >
          <el-form-item label="交易对">
            <el-input v-model="form.pair" disabled></el-input>
          </el-form-item>
          <el-form-item label="燃烧币种配置ID">
            <el-input v-model="form.pairBounsConfigId" disabled></el-input>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.startTime"
              style="width: 100%;"
              disabled
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间	">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.endTime"
              style="width: 100%;"
              disabled
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="目标币种">
            <el-input v-model="form.targetCoin" disabled></el-input>
          </el-form-item>
          <el-form-item label="目标币种分红总量">
            <el-input v-model="form.targetCoinBounsAmount" disabled></el-input>
          </el-form-item>
          <el-form-item label="目标币种发放比例">
            <el-input v-model="form.targetCoinGrantRate"></el-input>
          </el-form-item>

          <el-form-item label="交易币种">
            <el-input v-model="form.tradeCoin" disabled></el-input>
          </el-form-item>
          <el-form-item label="交易币种分红总量">
            <el-input v-model="form.tradeCoinBounsAmount" disabled></el-input>
          </el-form-item>
          <el-form-item label="交易币种发放比例">
            <el-input v-model="form.tradeCoinGrantRate"></el-input>
          </el-form-item>
          <el-form-item label="交易币种持仓总量">
            <el-input
              v-model="form.tradePositionTotalAmount"
              disabled
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="closeDialog()">取消</el-button>
            <el-button type="primary" @click="onSubmit()">立即创建</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import '../store';
import Pagination from 'components/pagination';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'DetailBox',
  components: {
    Pagination
  },
  data() {
    return {
      currentInfo: {},
      dialogVisible: false,
      form: {}
    };
  },
  computed: {
    ...mapState('burnCoinBonus', ['pairBounsRecordDetailInfo'])
  },
  methods: {
    ...mapActions('burnCoinBonus', [
      'getPairBounsRecordDetailList',
      'pairBounsAddOrUpdate'
    ]),
    setVisible(val) {
      this.dialogVisible = val;
    },
    setCurrentInfo(info) {
      this.form = { ...info };
    },

    onSubmit() {
      let pairBounsRecordVO = this.form;
      this.pairBounsAddOrUpdate(pairBounsRecordVO).then(res => {
        if (!res.code) {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success'
          });
          this.closeDialog();
          this.$emit('edit');
        }
      });
    },
    closeDialog() {
      this.form = {};
      this.dialogVisible = false;
    },

    refreshList() {
      this.getPairBounsRecordDetailList({
        pairBounsRecordId: '',
        coinType: '',
        endTime: '',
        page: this.page,
        size: this.size,
        startTime: '',
        userId: ''
      });
    },

    handleCurrentChange() {
      this.refreshList();
    }
  },
  mounted() {},
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue === true) {
        this.refreshList();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.detailBox-box {
}
</style>
